/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
// components imports
import { Col, Row } from "antd";
import { ServiceTypeSettingsForm } from "@/components/ProjectsComponents/Settings/ServiceTypeSettingsForm";

/**
 * Component for rendering project type settings.
 *
 * @component
 * @returns {JSX.Element} Rendered component
 */
export const ServiceTypeSettings = () => {
  // Render component content
  return (
    <Row>
      <Col xs={24}>
        <ServiceTypeSettingsForm />
      </Col>
    </Row>
  );
};
